<template>
  <section class="sidebar">
    <section class="menu-button">
      <button class="burger-btn" @click="toggleMenu">
        <div></div>
        <div></div>
        <div></div>
      </button>
    </section>

    <transition name="backdrop-fade">
      <section class="backdrop" @click="closeMenu" v-show="menuOpen"></section>
    </transition>
    <transition name="slide">
      <file-store-menu
        v-show="menuOpen"
        :mobileMode="true"
        @close="closeMenu"
      ></file-store-menu>
    </transition>
  </section>
</template>

<script>
import FileStoreMenu from '@/features/filestore/FileStoreMenu'

export default {
  name: 'MenuTrigger',
  components: { FileStoreMenu },
  data() {
    return {
      menuOpen: false
    }
  },
  watch: {
    // Bit of a dirty trick to close the menu after click on an item
    $route() {
      this.menuOpen = false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.burger-btn {
  height: 23px;
  width: 23px;
  padding: 0 2px;

  div {
    background-color: var(--text-color);
    height: 2px;
    margin: 4px auto;
  }
}

.menu-button {
  position: absolute;
  left: 6px;
  top: 6px;
}

.sidebar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}
</style>
